/* ==========================================================================
   AirTAC Products Landing Page — behavior
   Plain JS only: search, smooth scroll, RFQ prefill/validation, FAQ,
   UTM/click-id capture, mobile sticky CTA and dataLayer tracking.
   ========================================================================== */
(function () {
  "use strict";

  var root = document.querySelector(".lp-airtac-products");
  if (!root) return;
  if (root.dataset.lpInit === "1") return; // guard against double init
  root.dataset.lpInit = "1";

  /* ---------- dataLayer helpers ---------- */
  window.dataLayer = window.dataLayer || [];
  var BASE = { page_type: "paid_search_landing_page", page_slug: "airtac-products" };
  function push(obj) { window.dataLayer.push(Object.assign({}, BASE, obj)); }
  push({ event: "lp_airtac_view" });

  var params = new URLSearchParams(window.location.search);
  function byId(id) { return document.getElementById(id); }
  function setHidden(id, val) { var el = byId(id); if (el && val != null && val !== "") el.value = val; }

  /* ---------- Capture UTM / click IDs into RFQ hidden fields ---------- */
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gbraid", "wbraid"].forEach(function (k) {
    if (params.has(k)) setHidden("f-" + k, params.get(k));
  });
  setHidden("f-landing_page_url", window.location.href);
  setHidden("f-referrer", document.referrer);

  /* ---------- Footer year ---------- */
  var yearEl = byId("lp-footer-year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ---------- Trust bar mobile rotator ---------- */
  var rotator = byId("lp-trust-rotator-text");
  if (rotator) {
    var raw = rotator.getAttribute("data-items") || "";
    var items = raw.split("|").map(function (s) { return s.trim(); }).filter(Boolean);
    if (items.length > 1) {
      var idx = 0;
      setInterval(function () { idx = (idx + 1) % items.length; rotator.textContent = items[idx]; }, 3500);
    }
  }

  /* ---------- Smooth scroll for in-page anchors ---------- */
  document.querySelectorAll('.lp-airtac-products a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: "smooth" }); history.replaceState(null, "", id); }
    });
  });

  /* ---------- Model number search (theme-aligned + predictive dropdown) ---------- */
  var searchForm = byId("lp-model-search-form");
  if (searchForm) {
    var searchInput = byId("lp-model-search-input");
    var suggestBox = byId("lp-search-suggest");
    var predictiveEnabled = searchForm.getAttribute("data-predictive") === "true";
    var CLICK_IDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gbraid", "wbraid"];
    var suggestItems = [];
    var activeIndex = -1;

    // Build a Shopify search URL matching the theme: /search?type=product&options[sort_by]=price-descending&q=...
    function buildSearchUrl() {
      var action = searchForm.getAttribute("action") || "/search";
      var usp = new URLSearchParams();
      usp.set("type", "product");
      usp.set("options[sort_by]", "price-descending");
      usp.set("q", (searchInput.value || "").trim());
      CLICK_IDS.forEach(function (k) { if (params.has(k)) usp.set(k, params.get(k)); });
      return action + "?" + usp.toString();
    }

    function goToSearch() {
      var q = (searchInput.value || "").trim();
      if (!q) { searchInput.focus(); return; }
      push({ event: "lp_airtac_model_search", search_query: q });
      setHidden("f-search_query", q);
      window.location.href = buildSearchUrl();
    }

    searchForm.addEventListener("submit", function (e) {
      e.preventDefault();
      goToSearch();
    });

    if (predictiveEnabled && suggestBox) {
      var closeSuggest = function () {
        suggestBox.hidden = true; suggestBox.innerHTML = "";
        searchInput.setAttribute("aria-expanded", "false");
        searchInput.removeAttribute("aria-activedescendant");
        suggestItems = []; activeIndex = -1;
      };

      var highlight = function () {
        suggestItems.forEach(function (el, i) {
          var on = i === activeIndex;
          el.setAttribute("aria-selected", on ? "true" : "false");
          el.classList.toggle("is-active", on);
          if (on) { searchInput.setAttribute("aria-activedescendant", el.id); el.scrollIntoView({ block: "nearest" }); }
        });
      };

      var escapeHtml = function (s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      };

      var render = function (products, q) {
        if (!products || !products.length) {
          suggestBox.innerHTML = '<p class="lp-suggest__empty">No product matches. Press Enter to view all results or request a quote.</p>' +
            '<button type="button" class="lp-suggest__all" data-view-all>View all results for &ldquo;' + escapeHtml(q) + '&rdquo;</button>';
          suggestBox.hidden = false; searchInput.setAttribute("aria-expanded", "true");
        } else {
          var html = products.map(function (p, i) {
            var media = p.image
              ? '<img src="' + p.image + '" alt="" loading="lazy">'
              : '<span class="lp-icon" aria-hidden="true">inventory_2</span>';
            var price = p.price ? '<span class="lp-suggest__price">' + escapeHtml(p.price) + '</span>' : '';
            return '<a class="lp-suggest__item" role="option" id="lp-suggest-' + i + '" href="' + p.url + '" aria-selected="false">' +
              '<span class="lp-suggest__media">' + media + '</span>' +
              '<span class="lp-suggest__text"><span class="lp-suggest__title">' + escapeHtml(p.title) + '</span>' + price + '</span></a>';
          }).join("");
          html += '<button type="button" class="lp-suggest__all" data-view-all>View all results for &ldquo;' + escapeHtml(q) + '&rdquo;</button>';
          suggestBox.innerHTML = html;
          suggestBox.hidden = false; searchInput.setAttribute("aria-expanded", "true");
        }
        suggestItems = Array.prototype.slice.call(suggestBox.querySelectorAll('[role="option"], [data-view-all]'));
        activeIndex = -1;
        var viewAll = suggestBox.querySelector("[data-view-all]");
        if (viewAll) viewAll.addEventListener("click", goToSearch);
        suggestBox.querySelectorAll(".lp-suggest__item").forEach(function (a) {
          a.addEventListener("click", function () {
            push({ event: "lp_airtac_product_click", product_title: a.querySelector(".lp-suggest__title").textContent });
          });
        });
      };

      var doFetch = function (q) {
        var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last";
        fetch(url, { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data) return;
            var results = data.resources && data.resources.results && data.resources.results.products;
            render(results || [], q);
          })
          .catch(function () { /* fail silently, full search still works */ });
      };

      var debTimer;
      searchInput.addEventListener("input", function () {
        var q = (searchInput.value || "").trim();
        clearTimeout(debTimer);
        if (q.length < 2) { closeSuggest(); return; }
        debTimer = setTimeout(function () { doFetch(q); }, 250);
      });

      searchInput.addEventListener("keydown", function (e) {
        if (suggestBox.hidden || !suggestItems.length) return;
        if (e.key === "ArrowDown") { e.preventDefault(); activeIndex = Math.min(activeIndex + 1, suggestItems.length - 1); highlight(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); activeIndex = Math.max(activeIndex - 1, 0); highlight(); }
        else if (e.key === "Enter") { if (activeIndex >= 0) { e.preventDefault(); suggestItems[activeIndex].click(); } }
        else if (e.key === "Escape") { closeSuggest(); }
      });

      searchInput.addEventListener("focus", function () {
        var q = (searchInput.value || "").trim();
        if (q.length >= 2 && suggestBox.innerHTML) { suggestBox.hidden = false; searchInput.setAttribute("aria-expanded", "true"); }
      });

      document.addEventListener("click", function (e) { if (!searchForm.contains(e.target)) closeSuggest(); });
    }
  }

  /* ---------- Category click tracking + RFQ prefill ---------- */
  document.querySelectorAll(".lp-airtac-products [data-category]").forEach(function (el) {
    el.addEventListener("click", function () {
      var cat = el.getAttribute("data-category");
      push({ event: "lp_airtac_category_click", category: cat });
      if (el.getAttribute("href") === "#request-quote") {
        setHidden("f-clicked_category", cat);
        var modelField = byId("rfq-model");
        if (modelField && !modelField.value) modelField.value = cat;
      }
    });
  });

  /* ---------- Product card interactions (Add to cart / Ask) ---------- */
  document.querySelectorAll(".lp-airtac-products [data-lp-add]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      push({ event: "lp_airtac_product_click", product_sku: btn.dataset.sku, product_title: btn.dataset.title });
    });
  });
  document.querySelectorAll(".lp-airtac-products [data-lp-ask]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      push({ event: "lp_airtac_ask_model_click", product_sku: btn.dataset.sku, product_title: btn.dataset.title });
      setHidden("f-clicked_product_sku", btn.dataset.sku);
      setHidden("f-clicked_product_title", btn.dataset.title);
      var modelField = byId("rfq-model");
      if (modelField) modelField.value = btn.dataset.sku || btn.dataset.title || modelField.value;
      var rfq = byId("request-quote");
      if (rfq) rfq.scrollIntoView({ behavior: "smooth" });
    });
  });

  /* ---------- FAQ accordion (keyboard accessible via native button) ---------- */
  document.querySelectorAll(".lp-airtac-products .lp-faq__trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest(".lp-faq__item");
      var open = item.getAttribute("data-open") === "true";
      item.setAttribute("data-open", open ? "false" : "true");
      trigger.setAttribute("aria-expanded", open ? "false" : "true");
    });
  });

  /* ---------- RFQ form ---------- */
  var rfqForm = byId("rfq-form");
  if (rfqForm) {
    var started = false;
    rfqForm.addEventListener("focusin", function () {
      if (!started) { started = true; push({ event: "lp_airtac_rfq_start" }); }
    });
    rfqForm.addEventListener("submit", function (e) {
      var required = rfqForm.querySelectorAll("[required]");
      var valid = true;
      var first = null;
      required.forEach(function (field) {
        if (!field.value.trim()) {
          valid = false; field.setAttribute("aria-invalid", "true");
          if (!first) first = field;
        } else {
          field.removeAttribute("aria-invalid");
        }
      });
      if (!valid) { e.preventDefault(); if (first) first.focus(); return; }

      // Stash the conversion payload; fire it only after the successful reload
      // (Shopify posts the form and reloads with ?contact_posted=true).
      try {
        sessionStorage.setItem("lp_airtac_rfq_pending", JSON.stringify({
          event: "lp_airtac_rfq_submit",
          product_sku: (byId("f-clicked_product_sku") || {}).value || "",
          model_number: (byId("rfq-model") || {}).value || "",
          category: (byId("f-clicked_category") || {}).value || "",
          requested_quantity: (byId("rfq-qty") || {}).value || ""
        }));
      } catch (err) { /* sessionStorage unavailable, ignore */ }
    });
  }

  /* Show confirmation + fire the conversion event only after a successful post */
  if (params.get("contact_posted") === "true") {
    var conf = byId("rfq-confirmation");
    if (conf) { conf.classList.add("is-visible"); conf.scrollIntoView({ behavior: "smooth", block: "center" }); }
    try {
      var pendingRfq = sessionStorage.getItem("lp_airtac_rfq_pending");
      if (pendingRfq) { push(JSON.parse(pendingRfq)); sessionStorage.removeItem("lp_airtac_rfq_pending"); }
      else { push({ event: "lp_airtac_rfq_submit" }); }
    } catch (err) { push({ event: "lp_airtac_rfq_submit" }); }
  }

  /* ---------- Mobile sticky CTA ---------- */
  var sticky = byId("lp-mobile-sticky");
  var hero = byId("top");
  if (sticky && hero && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) sticky.classList.remove("is-visible");
        else sticky.classList.add("is-visible");
      });
    }, { threshold: 0 }).observe(hero);
  }
  if (sticky) {
    document.addEventListener("focusin", function (e) {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") sticky.classList.add("lp-sticky-hidden");
    });
    document.addEventListener("focusout", function (e) {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") sticky.classList.remove("lp-sticky-hidden");
    });
  }
})();
